const uniqueOptionsByDate = data => {
  // removes duplicated options, by picking the last created
  const optionMap = new Map(data.reverse().map(x => [x.label, x]))
  return [...optionMap.values()].reverse()
}

export default uniqueOptionsByDate
